import RequestAbstract from "../abstract";

export default class PartnersReferralCodes extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/partners/referral-codes";
    }
}
